// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9861) return "static/chunks/9861-b798b82a731812ee.js";
	if (chunkId === 5726) return "static/chunks/5726-6025d711efe6bca7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1012":"a91cb3e93608296a","4520":"c6097e3e2779285e","9567":"9f82af8a95beb46b"}[chunkId] + ".js";
};